import { render } from "./Insights.vue?vue&type=template&id=2767924a&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"

import "./Insights.vue?vue&type=style&index=0&id=2767924a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2767924a"]])

export default __exports__